import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Capabilities from './components/Capabilities';
import Work from './components/Work';
import Process from './components/Process';
import Contact from './components/Contact';
import Navbar from '../../components/feature/Navbar';
import CustomCursor from './components/CustomCursor';

export default function Home() {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <div className="relative bg-[#F8F9FB] min-h-screen">
      <CustomCursor mousePosition={mousePosition} />
      <Navbar mousePosition={mousePosition} />
      <Hero mousePosition={mousePosition} />
      <About />
      <Capabilities />
      <Work />
      <Process />
      <Contact />
    </div>
  );
}
